// extracted by mini-css-extract-plugin
export default {"container":"PostTargetSelector_container__qJ35s"};